// 酪蛋白产业链数字化（2221 版 · 7680×2160）内置默认内容
// 前端用 $CList(scope, key, fallback) 读取，后台未配置时回落到这里。
// 字段模型 src/cms/fields/industryChain.js 也引用本文件，保证默认值与页面当前内容一致。

// 左侧层级标签（flex 对应各层高度配比）
export const SIDE_LABELS = [
  { name: '智慧决策', flex: 0.78 },
  { name: '系统集成', flex: 0.80 },
  { name: 'MOM制造运营系统', flex: 2.97 },
  { name: '平台层', flex: 1.30 },
  { name: '网络传输', flex: 0.82 },
  { name: '设备层', flex: 1.13 },
]

// 1 智慧决策
export const DECISION_ITEMS = ['产品研发', '销售分析', '监控中心', '下游客户', '公司领导', '智能移动端']

// 2 系统集成
export const SYSTEMS = ['PLM系统', 'ERP系统', 'OA系统']

// 3 MOM 制造运营系统（cols 数 = 该组占用列数）
export const MOM_GROUPS = [
  { title: '生产建模', cols: [['工厂建模', '产线建模', 'BOM数据', '项目管理'], ['人员建模', '车间建模', '条码规则', '单据样式']] },
  { title: '订单计划', cols: [['原料收购', '计划排产', '异常清单', '计划跟踪']] },
  { title: '生产管理', cols: [['生产报工', '作业指示', '进度跟踪', '异常调度'], ['物料看板', '生产派工', '生产外协', '生产统计']] },
  { title: '仓储管理', cols: [['出入库管理', '库内管理', '物料拉动', '齐套分析']] },
  { title: '质量管理', cols: [['质量数据采集', '质量管理', '质量工具', '生产安全']] },
  { title: '设备管理', cols: [['设备台账', '设备维保', '设备监控', '设备备件']] },
  { title: '看板管理', cols: [['工位看板', '产线看板', '车间看板', 'CCR看板']] },
  { title: '工艺管理', cols: [['工艺流程', '卡片展示', '异常反馈', '图纸打印']] },
]

// 4 平台层
export const PLATFORM_ITEMS = ['设备接入', '设备管理', '云边协同', '数据清洗', '数据存储', '数据分析', '可视化', '等']
export const PLATFORM_BRAND_A = '工业物联'
export const PLATFORM_BRAND_B = '网平台'
export const INFRA_TEXT = 'IT / 云基础设施（服务器 · 存储 · 网络）'

// 5 网络传输
export const NETWORK_ITEMS = ['4G / WiFi', '互联网/工业以太网', 'NB-IoT', 'LoRa', 'MQTT', '等']

// 6 设备层
export const DEVICE_ITEMS = ['移栽AGV', '转运AGV', '装配机器人', '生产线', '输送线', '自动打码机', '视频监控', '测试设备']

// 右侧安全控制竖条文字
export const GUARD1_TEXT = '统一安全控制'
export const GUARD2_TEXT = '厂家安全控制'
